import { render } from "./Beginner.vue?vue&type=template&id=f7c3880a"
import script from "./Beginner.vue?vue&type=script&lang=js"
export * from "./Beginner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__